import * as React from 'react';
import { useEffect } from 'react';

export const useOnClickOutside = <T extends HTMLElement>(ref: React.MutableRefObject<T>, handler: (e: Event) => any) => {
    useEffect(() => {
        const handleClick: EventListener = (e: Event) => {
            if (ref.current && e.target instanceof Node && !ref.current.contains(e.target)) {
                handler(e);
            }
        };

        document.addEventListener('mousedown', handleClick);

        return () => document.removeEventListener('mousedown', handleClick);
    })
}
